import { render } from "./CompanyReportCWKConfiguration.vue?vue&type=template&id=3fcd7205&ts=true"
import script from "./CompanyReportCWKConfiguration.vue?vue&type=script&lang=ts"
export * from "./CompanyReportCWKConfiguration.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__